import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  assign_form_defaults,
  create_form_defaults,
  edit_form_defaults,
} from './user_management_helpers';
import user_management_methods from './user_management_methods';

export default {
  name: 'UserManagement',
  mixins: [alert_mixin],
  data: () => ({
    users: [],
    roles: [],
    entity_type_options: [],
    projects: [],
    is_loading: false,
    roles_loading: false,
    entity_types_loading: false,
    projects_loading: false,
    assigned_projects_loading: false,
    creating_user: false,
    updating_user: false,
    assigning_user: false,
    create_form: create_form_defaults(),
    edit_form: edit_form_defaults(),
    assign_form: assign_form_defaults(),
    show_project_dropdown: false,
    pagination: null
  }),
  mounted() {
    this.fetch_users();
    this.fetch_roles();
  },
  computed: {
    active_users_count() {
      return this.users.filter((user) => user.is_active !== false).length;
    },
    inactive_users_count() {
      return this.users.filter((user) => user.is_active === false).length;
    },
    filtered_projects() {
      const search = String(this.assign_form.project_search || '').toLowerCase().trim();
      if (!search) return this.projects;

      return this.projects.filter((project) =>
        this.project_display_name(project).toLowerCase().includes(search)
      );
    },
    selected_project_name() {
      const selected_ids = Array.isArray(this.assign_form.project_ids)
        ? this.assign_form.project_ids
        : [];

      if (!selected_ids.length) return 'Select Projects';

      if (selected_ids.length === 1) {
        const selected_project = this.projects.find(
          (project) => String(project.id) === String(selected_ids[0])
        );
        return selected_project ? this.project_display_name(selected_project) : '1 project selected';
      }

      return `${selected_ids.length} projects selected`;
    }
  },
  methods: user_management_methods
};
